export default __webpack_public_path__ + "static/media/bottom-banner-question.b671d6cd.png";